const AboutPageTranslations = {
  testimonials: [
    {
      slug: 'microsoft',
      title: 'Microsoft',
      testimonial: 'CGTrader is a life-saver for finding unique and high quality 3D models.',
      author: 'Anthony, Microsoft',
      imageHeight: 40,
    },
    {
      slug: 'eon_reality',
      title: 'EON Reality',
      testimonial: `CGTrader provides industry-leading, quality models for production and
naturally we find them incredibly useful.`,
      author: 'Adam Bladowski, EON Reality',
      imageHeight: 60,
    },
    {
      slug: 'nike',
      title: 'Nike',
      testimonial: 'CGTrader is my favorite 3D source because of the range of assets you expose.',
      author: 'Jason, Nike',
      imageHeight: 40,
    },
    {
      slug: 'petco',
      title: 'Pet Co.',
      testimonial: 'CGTrader is highly skilled and was a pleasure to work with.',
      author: 'Alpinhound Pet Co.',
      imageHeight: 50,
    },
  ],
}

export default AboutPageTranslations
